import { render, staticRenderFns } from "./EmptyResults.vue?vue&type=template&id=0edd0e9f&scoped=true"
import script from "./EmptyResults.vue?vue&type=script&lang=js"
export * from "./EmptyResults.vue?vue&type=script&lang=js"
import style0 from "./EmptyResults.vue?vue&type=style&index=0&id=0edd0e9f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edd0e9f",
  null
  
)

export default component.exports